import { useState, useContext } from 'react';
import { MemberContext } from '../components/context';

const getVal = require('lodash/get');

const useMemberSelection = ({ formSubmissionPayload, setFormSubmissionPayload }) => {
  const memberDetails = useContext(MemberContext);
  const [selectedMemberInfo, setSelectedMemberInfo] = useState(null);
  const [selectedSuppAccount, setSelectedSuppAccount] = useState(null);

  /**
   * create plain json for prefilling into form
   */
  const setSelectedMember = async (memberKey) => {
    if (memberKey) {
      let memberReqDetails;
      memberDetails.map((info) => {
        if ((info.accountToken === memberKey)
          || (info.identifiers && ((info.identifiers.accountKey === memberKey)
            || (info.identifiers.displayAccountNumber === memberKey)))) {
          memberReqDetails = {
            accountToken: info.accountToken,
            supplementaryAccounts: info.supplementaryAccounts,
          };
          const memberKeysToExpand = ['identifiers', 'holder', 'holder.profile', 'product', 'holder.contacts.phone[1]', 'holder.contacts.address[0]'];
          memberKeysToExpand.forEach((key) => {
            const keyObject = getVal(info, key) ? getVal(info, key) : null;
            if (keyObject) {
              memberReqDetails = { ...memberReqDetails, ...keyObject };
            }
          });
          /**
           * Add different addressses and phone numbers under different keys
           * E.g. primaryAddress, alternateAdddress, employerAddress, etc
           * E.g. homePhoneNumber, workPhoneNumber, mobilePhoneNumber, faxNumber, etc
           */
          const addresses = info?.holder?.contacts?.address;
          const phones = info?.holder?.contacts?.phone;
          if (addresses) {
            addresses.forEach((address) => {
              const addressType = `${address.type}Address`;
              if (memberReqDetails[addressType]) {
                if (address.purpose?.includes('DEFAULT')) {
                  memberReqDetails[addressType] = { ...address };
                }
              } else {
                memberReqDetails[addressType] = address;
              }
              if (address.purpose?.includes('BILLING')) {
                memberReqDetails.BILLINGAddress = { ...address };
              }
            });
          }
          if (phones) {
            phones.forEach((phone) => {
              const phoneType = `${phone.type}PhoneNumber`;
              memberReqDetails[phoneType] = phone;
            });
          }
        }
        return true;
      });
      /* Update member information */
      setFormSubmissionPayload({
        ...formSubmissionPayload,
        elemId: null,
        suppFlag: !!(memberReqDetails && memberReqDetails.supplementaryAccounts
          && memberReqDetails.supplementaryAccounts.length > 0),
      });
      setSelectedMemberInfo(memberReqDetails);
    } else {
      setSelectedMemberInfo(null);
    }
  };

  const setSuppSelectedMember = async (memberKey) => {
    if (memberKey) {
      selectedMemberInfo.supplementaryAccounts.map((info) => {
        if ((info.accountToken === memberKey)
          || (info.identifiers && ((info.identifiers.accountKey === memberKey)
            || (info.identifiers.displayAccountNumber === memberKey)))) {
          setSelectedSuppAccount(info);
        }
        return true;
      });
    } else {
      setSelectedSuppAccount(null);
    }
  };

  return {
    memberDetails,
    selectedMemberInfo,
    setSelectedMemberInfo,
    selectedSuppAccount,
    setSelectedSuppAccount,
    setSelectedMember,
    setSuppSelectedMember,
  };
};

export default useMemberSelection;
